import type { Hor } from '@/api/types/hor'
import type {
  MatchCriteriaKey,
  MatchCriteriaKeyType,
  PropertyMatch,
} from '@/api/types/matchCriteria'

export type PropertyComparisonsProps = {
  propertyMatch?: PropertyMatch
  propertyMatchHighlights?: Partial<
    Record<MatchCriteriaKeyType, MatchCriteriaKey>
  >
}

export const usePropertyMatch = (
  hor: Hor,
  propertyId: number | string
): PropertyComparisonsProps => {
  const horProperty = (hor?.selectedPropertyList || []).find(
    (item) => Number(item.id) === Number(propertyId) || item.hash === propertyId
  )
  const propertyMatch = horProperty?.match

  // better mapping for highlights in the shortlist
  const propertyMatchHighlights = Object.fromEntries(
    (propertyMatch?.keyInsights || []).map((item) => [item.type, { ...item }])
  )

  return {
    propertyMatch: {
      band: propertyMatch?.band ?? 'low',
      criteria: propertyMatch?.criteria || [],
      keyInsights: propertyMatch?.keyInsights || [],
      totalScore: propertyMatch?.totalScore ?? 0,
    },
    propertyMatchHighlights,
  }
}
